import { useState, useEffect, useContext } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { AuthContext } from '../context/authContext';
import ModalMapeo from '../components/ModalMapeo';

//const API_URL = import.meta.env.VITE_API_URL;

const EntidadRequestDetailPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { token, role, userMunicipio, isEspecial } = useContext(AuthContext);
    
    const [request, setRequest] = useState(null);
    console.group('Debug ');
    console.log('role:', role);
    console.log('request.status:', request?.status);
    //console.log('canValidate result:', canValidate());
    console.groupEnd();
    
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [actionLoading, setActionLoading] = useState(false);
    const [validationNotes, setValidationNotes] = useState('');
    const [rejectionReason, setRejectionReason] = useState('');
    const [showRejectionModal, setShowRejectionModal] = useState(false);
    const [tempGeomSede, setTempGeomSede] = useState(null);
    const [allowValidationWithoutGeom, setAllowValidationWithoutGeom] = useState(false);
    const [existingRequests, setExistingRequests] = useState([]);
    const [showReplaceModal, setShowReplaceModal] = useState(false);
    const [replaceReason, setReplaceReason] = useState('');
    const [entidadesMunicipio, setEntidadesMunicipio] = useState([]);
    const [selectedEntidad, setSelectedEntidad] = useState(null);
    const [showVincularModal, setShowVincularModal] = useState(false);
    const [showBajaModal, setShowBajaModal] = useState(false);
    const [bajaReason, setBajaReason] = useState('');

    useEffect(() => {
        fetchRequestDetail();
    }, [id, token]);

    useEffect(() => {
        console.log('useEffect id_red_asignado:', request?.id_red_asignado);
        if (request?.id_red_asignado) {
            fetchExistingRequests(request.id_red_asignado);
        }
    }, [request?.id_red_asignado, token]);

    const fetchRequestDetail = async () => {
        try {
            const response = await fetch(`/api/entidad-requests/requests/${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (!response.ok) {
                throw new Error('Error al cargar la solicitud');
            }

            const data = await response.json();
            setRequest(data);
            if (data.sin_sede) {
                setAllowValidationWithoutGeom(true);
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleDownloadPdf = async (filename) => {
        try {
            const response = await fetch(`/api/entidad-requests/requests/${id}/pdf`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            if (!response.ok) {
                if (response.status === 401) {
                    throw new Error('No autorizado. Inicie sesión nuevamente.');
                }
                if (response.status === 404) {
                    throw new Error('PDF no encontrado.');
                }
                throw new Error('Error al descargar el PDF');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename || 'nota.pdf';
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        } catch (err) {
            setError(err.message);
        }
    };

    const convertToGeoJSON = (geomData) => {
        if (!geomData) return null;
        // If already GeoJSON object, return as is
        if (geomData.type && geomData.coordinates) {
            return geomData;
        }
        // If array [lng, lat], convert to GeoJSON
        if (Array.isArray(geomData) && geomData.length >= 2) {
            return {
                type: 'Point',
                coordinates: [geomData[0], geomData[1]]
            };
        }
        return null;
    };

    const formatCoordinates = (geomData) => {
        if (!geomData) return 'No disponible';
        // If GeoJSON object with coordinates
        if (geomData.type === 'Point' && geomData.coordinates) {
            const [lng, lat] = geomData.coordinates;
            return `${lat.toFixed(6)}, ${lng.toFixed(6)}`;
        }
        // Fallback for old format (string)
        return typeof geomData === 'string' ? geomData : JSON.stringify(geomData);
    };

    const handleValidate = async () => {
        setActionLoading(true);
        try {
            const geomSedeGeoJSON = convertToGeoJSON(tempGeomSede);
            const response = await fetch(`/api/entidad-requests/requests/${id}/validate`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ 
                    validation_notes: validationNotes,
                    geom_sede: geomSedeGeoJSON,
                    sin_sede: request.sin_sede || false,
                    allow_without_geom: allowValidationWithoutGeom || request.sin_sede
                })
            });

            if (!response.ok) {
                throw new Error('Error al validar la solicitud');
            }

            const data = await response.json();
            setRequest(data.request);
            alert('Solicitud validada correctamente');
        } catch (err) {
            alert(err.message);
        } finally {
            setActionLoading(false);
        }
    };

    const fetchExistingRequests = async (idRed) => {
        try {
            console.log('Fetching existing requests for idRed:', idRed);
            const response = await fetch(`/api/entidad-requests/requests?status=aprobado&id_red_asignado=${idRed}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            console.log('Response status:', response.status);
            if (response.ok) {
                const data = await response.json();
                console.log('Response data:', data);
                // Backend returns array directly or {requests: [...]}
                const requestsArray = Array.isArray(data) ? data : (data.requests || []);
                const others = requestsArray.filter(r => r.id !== parseInt(id)) || [];
                console.log('Filtered others:', others);
                setExistingRequests(others);
            }
        } catch (err) {
            console.error('Error fetching existing requests:', err);
        }
    };

    const fetchEntidadesMunicipio = async (codigoPartido) => {
        console.log('fetchEntidadesMunicipio called with:', codigoPartido);
        try {
            const response = await fetch(`/api/entidad-requests/entidades-municipio/${codigoPartido}`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            console.log('fetchEntidadesMunicipio response status:', response.status);
            if (response.ok) {
                const data = await response.json();
                console.log('fetchEntidadesMunicipio data:', data);
                setEntidadesMunicipio(data.entidades || []);
            } else {
                const errorText = await response.text();
                console.error('fetchEntidadesMunicipio error:', response.status, errorText);
            }
        } catch (err) {
            console.error('Error fetching entidades del municipio:', err);
        }
    };

    const handleVincularEntidad = async () => {
        if (!selectedEntidad) {
            alert('Debe seleccionar una entidad');
            return;
        }
        setActionLoading(true);
        try {
            const response = await fetch(`/api/entidad-requests/requests/${id}/vincular-entidad`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ id_red_asignado: selectedEntidad.id_red })
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Error al vincular entidad');
            }

            const data = await response.json();
            setRequest(data.request);
            setShowVincularModal(false);
            setSelectedEntidad(null);
            alert('Entidad vinculada correctamente');
        } catch (err) {
            alert(err.message);
        } finally {
            setActionLoading(false);
        }
    };

    useEffect(() => {
        console.log('=== USEEFFECT entidadesMunicipio TRIGGERED ===');
        console.log('Dependencies:', {
            codigo_partido: request?.codigo_partido,
            id_red_asignado: request?.id_red_asignado,
            status: request?.status,
            hasToken: !!token
        });
        
        const shouldFetch = request?.codigo_partido && !request?.id_red_asignado && request?.status === 'pendiente';
        console.log('Should fetch?', shouldFetch);
        
        if (shouldFetch) {
            console.log('Calling fetchEntidadesMunicipio with:', request.codigo_partido);
            fetchEntidadesMunicipio(request.codigo_partido);
        }
    }, [request?.codigo_partido, request?.id_red_asignado, request?.status, token]);

    const handleReplaceAccess = async () => {
        if (!replaceReason.trim()) {
            alert('Debe ingresar un motivo para el reemplazo');
            return;
        }
        setActionLoading(true);
        try {
            const response = await fetch(`/api/entidad-requests/requests/${id}/replace-access`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ reason: replaceReason })
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Error al reemplazar el acceso');
            }

            const data = await response.json();
            setRequest(data.request);
            setShowReplaceModal(false);
            setReplaceReason('');
            alert('Acceso reemplazado exitosamente. Se notificó al usuario anterior.');
        } catch (err) {
            alert(err.message);
        } finally {
            setActionLoading(false);
        }
    };

    const handleApprove = async () => {
        setActionLoading(true);
        try {
            const response = await fetch(`/api/entidad-requests/requests/${id}/approve`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            });

            if (!response.ok) {
                throw new Error('Error al aprobar la solicitud');
            }

            const data = await response.json();
            setRequest(data.request);
            alert(`Solicitud aprobada. ID de entidad asignado: ${data.request.id_red_asignado}`);
        } catch (err) {
            alert(err.message);
        } finally {
            setActionLoading(false);
        }
    };

    const handleReject = async () => {
        if (!rejectionReason.trim()) {
            alert('Debe ingresar un motivo de rechazo');
            return;
        }

        setActionLoading(true);
        try {
            const response = await fetch(`/api/entidad-requests/requests/${id}/reject`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ rejection_reason: rejectionReason })
            });

            if (!response.ok) {
                throw new Error('Error al rechazar la solicitud');
            }

            const data = await response.json();
            setRequest(data.request);
            setShowRejectionModal(false);
            alert('Solicitud rechazada');
        } catch (err) {
            alert(err.message);
        } finally {
            setActionLoading(false);
        }
    };

    const handleDarDeBaja = async () => {
        if (!bajaReason || !bajaReason.trim()) {
            alert('Debe ingresar un motivo de baja');
            return;
        }

        setActionLoading(true);
        try {
            const response = await fetch(`/api/entidad-requests/requests/${id}/baja`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ motivo_baja: bajaReason })
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Error al dar de baja el permiso de edición');
            }

            const data = await response.json();
            setRequest(data.request);
            setShowBajaModal(false);
            alert('Permiso de edición dado de baja exitosamente');
        } catch (err) {
            alert(err.message);
        } finally {
            setActionLoading(false);
        }
    };

    const getStatusBadge = (status) => {
        const styles = {
            pendiente: 'bg-yellow-100 text-yellow-800',
            validado: 'bg-blue-100 text-blue-800',
            aprobado: 'bg-green-100 text-green-800',
            rechazado: 'bg-red-100 text-red-800',
            completado: 'bg-purple-100 text-purple-800',
            baja: 'bg-gray-100 text-gray-600'
        };
        const labels = {
            pendiente: 'Pendiente',
            validado: 'Validado',
            aprobado: 'Aprobado',
            rechazado: 'Rechazado',
            completado: 'Completado',
            baja: 'Baja'
        };
        return (
            <span className={`px-3 py-1 rounded-full text-sm font-medium ${styles[status] || 'bg-gray-100 text-gray-800'}`}>
                {labels[status] || status}
            </span>
        );
    };

    const canValidate = () => {
        console.log('[canValidate] request:', request?.id, 'status:', request?.status, 'role:', role, 'userMunicipio:', userMunicipio, 'codigo_partido:', request?.codigo_partido, 'assigned_to_municipal:', request?.assigned_to_municipal);
        if (!request) return false;
        if (request.status !== 'pendiente') return false;
        // Municipal users can validate if request belongs to their municipality
        if (role === 'editor_municipio') {
            const userMun = String(userMunicipio || '');
            const reqPartido = String(request.codigo_partido || '');
            // Allow if same municipality OR if assigned to municipal
            if (userMun === reqPartido || request.assigned_to_municipal) return true;
        }
        // Provincial users can validate if assigned to them or if no municipal assigned
        if (role === 'editor_provincial') return true;
        if (role === 'admin') return true;
        return false;
    };

    const canApprove = () => {
        if (!request) return false;
        if (request.status !== 'validado') return false;
        // Only validated requests can be approved
        if (role === 'editor_municipio') {
            const userMun = String(userMunicipio || '');
            const reqPartido = String(request.codigo_partido || '');
            // Allow if same municipality AND validated by municipal
            if ((userMun === reqPartido || request.assigned_to_municipal) && request.validated_by_municipio) return true;
        }
        if (role === 'editor_provincial' && (request.validated_by_provincial || request.assigned_to_provincial)) return true;
        if (role === 'admin') return true;
        return false;
    };

    const canDarDeBaja = () => {
        console.log('DEBUG canDarDeBaja - role:', role, 'isEspecial:', isEspecial, 'request:', request);
        if (!request) return false;
        // Solo para status aprobado o completado
        const validStatuses = ['aprobado', 'completado'];
        if (!request.status || !validStatuses.includes(request.status)) return false;
        // Provincial isEspecial puede dar de baja cualquier entidad
        if ((role === 'provincial' || role === 'editor_provincial') && isEspecial) return true;
        // Editor municipal puede dar de baja solo si coincide el partido
        if (role === 'editor_municipio') {
            const userMun = String(userMunicipio || '');
            const reqPartido = String(request.codigo_partido || '');
            return userMun === reqPartido;
        }
        return false;
    };

    if (loading) {
        return (
            <div className="container mx-auto p-6">
                <div className="text-center py-10">Cargando solicitud...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="container mx-auto p-6">
                <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                    {error}
                </div>
                <button
                    onClick={() => navigate('/admin/solicitudes-entidades')}
                    className="text-blue-600 hover:text-blue-800"
                >
                    ← Volver al listado
                </button>
            </div>
        );
    }

    if (!request) {
        return (
            <div className="container mx-auto p-6">
                <div className="text-center py-10">Solicitud no encontrada</div>
            </div>
        );
    }

    return (
        <div className="container mx-auto p-6 max-w-4xl">
            <button
                onClick={() => navigate('/admin/solicitudes-entidades')}
                className="text-blue-600 hover:text-blue-800 mb-4 flex items-center"
            >
                ← Volver al listado
            </button>

            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
                <div className="flex justify-between items-center mb-6">
                    <h1 className="text-2xl font-bold text-gray-800 dark:text-white">
                        Solicitud #{request.id}
                    </h1>
                    {getStatusBadge(request.status)}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                    <div>
                        <h3 className="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase mb-2">
                            Información de la Entidad
                        </h3>
                        <div className="space-y-3">
                            <div>
                                <label className="text-xs text-gray-500">Nombre de la Institución</label>
                                <p className="text-gray-900 dark:text-white font-medium">{request.nombre_institucion}</p>
                            </div>
                            <div>
                                <label className="text-xs text-gray-500">Presidente/Responsable</label>
                                <p className="text-gray-900 dark:text-white">{request.nombre_presidente}</p>
                            </div>
                            <div>
                                <label className="text-xs text-gray-500">Partido</label>
                                <p className="text-gray-900 dark:text-white">{request.nombre_partido || request.codigo_partido}</p>
                            </div>
                            {request.id_red_entidad && (
                                <div>
                                    <label className="text-xs text-gray-500">ID RED Asignado</label>
                                    <p className="text-green-600 font-bold">{request.id_red_entidad}</p>
                                </div>
                            )}
                        </div>
                    </div>

                    <div>
                        <h3 className="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase mb-2">
                            Información de Contacto
                        </h3>
                        <div className="space-y-3">
                            <div>
                                <label className="text-xs text-gray-500">Email</label>
                                <p className="text-gray-900 dark:text-white">{request.email_contacto}</p>
                            </div>
                            <div>
                                <label className="text-xs text-gray-500">Teléfono</label>
                                <p className="text-gray-900 dark:text-white">{request.telefono_contacto || 'No proporcionado'}</p>
                            </div>
                            <div>
                                <label className="text-xs text-gray-500">Fecha de Solicitud</label>
                                <p className="text-gray-900 dark:text-white">
                                    {new Date(request.created_at).toLocaleString()}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {request.nota_pdf_path && (
                    <div className="mb-6">
                        <h3 className="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase mb-2">
                            Documento Adjunto
                        </h3>
                        <button
                            onClick={() => handleDownloadPdf(request.nota_pdf_name || 'nota.pdf')}
                            className="inline-flex items-center px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-md transition-colors cursor-pointer border-none"
                        >
                            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                            Ver PDF
                        </button>
                    </div>
                )}

                {request.sin_sede ? (
                    <div className="mb-6">
                        <h3 className="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase mb-2">
                            Ubicación de la Sede
                        </h3>
                        <div className="bg-gray-100 dark:bg-gray-700 rounded-md p-3">
                            <div className="flex items-center gap-2">
                                <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" />
                                </svg>
                                <p className="text-sm text-gray-600 dark:text-gray-300">
                                    La entidad indicó que <strong>no posee sede física</strong>.
                                </p>
                            </div>
                        </div>
                    </div>
                ) : request.geom_sede ? (
                    <div className="mb-6">
                        <h3 className="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase mb-2">
                            Ubicación de la Sede
                        </h3>
                        <div className="bg-gray-100 dark:bg-gray-700 rounded-md p-3">
                            <p className="text-sm text-gray-700 dark:text-gray-300">Coordenadas: {formatCoordinates(request.geom_sede)}</p>
                        </div>
                    </div>
                ) : (
                    <div className="mb-6">
                        <h3 className="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase mb-2">
                            Ubicación de la Sede
                        </h3>
                        <div className="bg-yellow-50 border border-yellow-200 rounded-md p-3">
                            <p className="text-sm text-yellow-700 mb-2">
                                La entidad no proporcionó coordenadas de la sede.
                            </p>
                            {canValidate() && (
                                <>
                                    <p className="text-xs text-gray-500 mb-2">
                                        Partido: {request.nombre_partido || request.codigo_partido || 'No definido'}
                                    </p>
                                    <ModalMapeo
                                        partido={request.codigo_partido}
                                        onSave={(data) => {
                                            console.log('ModalMapeo onSave data:', data);
                                            setTempGeomSede(data?.geom_sede || data);
                                        }}
                                        initialData={tempGeomSede}
                                        disabled={!request.codigo_partido}
                                    />
                                </>
                            )}
                            {tempGeomSede && (
                                <p className="text-sm text-green-600 mt-2">
                                    ✓ Ubicación cargada correctamente
                                </p>
                            )}
                        </div>
                    </div>
                )}

                {/* Validation History */}
                {(request.validation_notes || request.rejection_reason || request.validated_at) && (
                    <div className="mb-6 border-t pt-6">
                        <h3 className="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase mb-3">
                            Historial de Validación
                        </h3>
                        {request.validated_at && (
                            <div className="mb-3">
                                <p className="text-sm text-gray-600">
                                    <span className="font-medium">Validado el:</span> {new Date(request.validated_at).toLocaleString()}
                                </p>
                                {request.validated_by_municipio && (
                                    <p className="text-sm text-gray-600">Por: Usuario Municipal</p>
                                )}
                                {request.validated_by_provincial && (
                                    <p className="text-sm text-gray-600">Por: Usuario Provincial</p>
                                )}
                            </div>
                        )}
                        {request.validation_notes && (
                            <div className="bg-blue-50 dark:bg-blue-900/20 p-3 rounded-md mb-3">
                                <p className="text-sm font-medium text-blue-800 dark:text-blue-200 mb-1">Notas de validación:</p>
                                <p className="text-sm text-blue-700 dark:text-blue-300">{request.validation_notes}</p>
                            </div>
                        )}
                        {request.rejection_reason && (
                            <div className="bg-red-50 dark:bg-red-900/20 p-3 rounded-md">
                                <p className="text-sm font-medium text-red-800 dark:text-red-200 mb-1">Motivo de rechazo:</p>
                                <p className="text-sm text-red-700 dark:text-red-300">{request.rejection_reason}</p>
                            </div>
                        )}
                    </div>
                )}

                {/* Existing Entity Indicator */}
                {request.id_red_asignado && (
                    <div className="mb-6 bg-green-50 border border-green-200 rounded-md p-4">
                        <div className="flex items-start">
                            <div className="flex-shrink-0">
                                <svg className="h-5 w-5 text-green-600" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                </svg>
                            </div>
                            <div className="ml-3">
                                <p className="text-sm font-medium text-green-800">
                                    Entidad existente en el sistema
                                </p>
                                <p className="text-sm text-green-700 mt-1">
                                    ID: <span className="font-mono font-medium">{request.id_red_asignado}</span>
                                </p>
                                <p className="text-xs text-green-600 mt-1">
                                    Al aprobar, se otorgará acceso para editar esta entidad. No se generará un nuevo ID.
                                </p>
                            </div>
                        </div>
                    </div>
                )}

                {/* Action Buttons */}
                {canValidate() && (
                    <div className="border-t pt-6">
                        <h3 className="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase mb-3">
                            Acciones de Validación
                        </h3>
                        <p className="text-sm text-gray-600 mb-4">
                            {request.id_red_asignado 
                                ? 'Valide que los datos corresponden a la entidad existente.' 
                                : 'Valide los datos de la nueva entidad antes de aprobar.'}
                        </p>

                        {/* Entidades del municipio disponibles para vincular */}
                        {!request.id_red_asignado && entidadesMunicipio.length > 0 && (
                            <div className="mb-4 p-4 bg-blue-50 border border-blue-200 rounded-md">
                                <p className="text-sm font-medium text-blue-800 mb-2">
                                    Entidades existentes en este municipio:
                                </p>
                                <p className="text-xs text-blue-600 mb-3">
                                    Si la solicitud corresponde a una entidad existente, selecciónela. Si tiene editor, se ofrecerá reemplazar el acceso:
                                </p>
                                <div className="max-h-40 overflow-y-auto space-y-2">
                                    {entidadesMunicipio.map((entidad) => (
                                        <div 
                                            key={entidad.id}
                                            onClick={() => setSelectedEntidad(selectedEntidad?.id === entidad.id ? null : entidad)}
                                            className={`p-2 rounded cursor-pointer border ${
                                                selectedEntidad?.id === entidad.id 
                                                    ? 'bg-blue-200 border-blue-400' 
                                                    : 'bg-white border-blue-100 hover:bg-blue-50'
                                            }`}
                                        >
                                            <div className="flex justify-between items-start">
                                                <p className="text-sm font-medium text-gray-800">
                                                    {entidad.nombre_completo} ({entidad.id_red})
                                                </p>
                                                {entidad.tiene_editor ? (
                                                    <span className="text-xs bg-orange-100 text-orange-700 px-2 py-0.5 rounded">
                                                        Tiene editor
                                                    </span>
                                                ) : (
                                                    <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded">
                                                        Sin editor
                                                    </span>
                                                )}
                                            </div>
                                            <p className="text-xs text-gray-500">
                                                {entidad.nombre_fantasia || 'Sin nombre de fantasía'} - {entidad.municipio || 'Sin municipio'}
                                            </p>
                                            <p className="text-xs text-gray-400">
                                                {entidad.tipo_entidad || ''} {entidad.email ? `| ${entidad.email}` : ''}
                                            </p>
                                            {entidad.tiene_editor && (
                                                <p className="text-xs text-orange-600 mt-1">
                                                    Editor actual: {entidad.editor_nombre || entidad.editor_email || 'No disponible'}
                                                </p>
                                            )}
                                        </div>
                                    ))}
                                </div>
                                {selectedEntidad && (
                                    <div className="mt-3">
                                        {selectedEntidad.tiene_editor ? (
                                            <div className="bg-orange-50 border border-orange-200 p-3 rounded mb-3">
                                                <p className="text-sm text-orange-800 font-medium">
                                                    ⚠️ Esta entidad ya tiene un editor
                                                </p>
                                                <p className="text-xs text-orange-600 mt-1">
                                                    Al vincular, se deberá usar el flujo de "Reemplazar Acceso" durante la aprobación.
                                                </p>
                                            </div>
                                        ) : null}
                                        <div className="flex gap-2">
                                            <button
                                                onClick={handleVincularEntidad}
                                                disabled={actionLoading}
                                                className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded transition-colors disabled:opacity-50"
                                            >
                                                {actionLoading ? 'Vinculando...' : `Vincular${selectedEntidad.tiene_editor ? ' (Requerirá reemplazo)' : ''}`}
                                            </button>
                                            <button
                                                onClick={() => setSelectedEntidad(null)}
                                                className="px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 text-sm font-medium rounded transition-colors"
                                            >
                                                Cancelar
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}

                        <div className="space-y-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                    Notas de validación (opcional)
                                </label>
                                <textarea
                                    value={validationNotes}
                                    onChange={(e) => setValidationNotes(e.target.value)}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    rows="3"
                                    placeholder="Ingrese observaciones sobre la validación..."
                                />
                            </div>
                            <div className="mb-4">
                                <label className="flex items-center space-x-2 cursor-pointer">
                                    <input
                                        type="checkbox"
                                        checked={allowValidationWithoutGeom || request?.sin_sede}
                                        onChange={(e) => setAllowValidationWithoutGeom(e.target.checked)}
                                        disabled={request?.sin_sede}
                                        className="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
                                    />
                                    <span className="text-sm text-gray-700">
                                        {request?.sin_sede
                                            ? 'La entidad indicó que no posee sede física'
                                            : 'Permitir validación sin ubicación (la entidad la cargará después)'
                                        }
                                    </span>
                                </label>
                            </div>
                            <div className="flex gap-3">
                                <button
                                    onClick={handleValidate}
                                    disabled={actionLoading || (!request.sin_sede && !request.geom_sede && !tempGeomSede && !allowValidationWithoutGeom)}
                                    className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-md transition-colors disabled:opacity-50"
                                >
                                    {actionLoading ? 'Procesando...' : 'Validar Solicitud'}
                                </button>
                                <button
                                    onClick={() => setShowRejectionModal(true)}
                                    disabled={actionLoading}
                                    className="px-6 py-2 bg-red-600 hover:bg-red-700 text-white font-medium rounded-md transition-colors disabled:opacity-50"
                                >
                                    Rechazar
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {canApprove() && (
                    <div className="border-t pt-6">
                        <h3 className="text-sm font-semibold text-gray-500 dark:text-gray-400 uppercase mb-3">
                            Aprobación Final
                        </h3>
                        
                        {/* Warning for existing approved requests */}
                        {existingRequests.length > 0 && (
                            <div className="mb-4 p-4 bg-yellow-50 border border-yellow-400 rounded-md">
                                <div className="flex items-start">
                                    <svg className="w-5 h-5 text-yellow-600 mt-0.5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                    </svg>
                                    <div>
                                        <p className="text-sm font-medium text-yellow-800">
                                            ¡Atención! Ya existe acceso aprobado para esta entidad
                                        </p>
                                        <p className="text-xs text-yellow-700 mt-1">
                                            La entidad <strong>{request.id_red_asignado}</strong> ya tiene acceso de edición otorgado a otro usuario.
                                            Puede rechazar esta solicitud o reemplazar el acceso existente.
                                        </p>
                                        {existingRequests.map((req) => (
                                            <div key={req.id} className="mt-2 text-xs text-yellow-700 bg-yellow-100 p-2 rounded">
                                                <strong>Acceso actual:</strong> {req.nombre_presidente || 'No disponible'} ({req.email_contacto}) -
                                                Aprobado el {new Date(req.approved_at).toLocaleDateString()}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}
                        
                        <p className="text-sm text-gray-600 mb-4">
                            {request.id_red_asignado 
                                ? `Al aprobar, se otorgará acceso de edición a la entidad ${request.id_red_asignado}. Se enviará un email al contacto con el link de registro.` 
                                : 'Al aprobar esta solicitud, se generará un ID único para la nueva entidad y se enviará un email al contacto con el link de registro.'}
                        </p>
                        
                        <div className="flex gap-3">
                            {existingRequests.length > 0 ? (
                                <>
                                    <button
                                        onClick={() => setShowRejectionModal(true)}
                                        disabled={actionLoading}
                                        className="px-6 py-2 bg-red-600 hover:bg-red-700 text-white font-medium rounded-md transition-colors disabled:opacity-50"
                                    >
                                        Rechazar Solicitud
                                    </button>
                                    <button
                                        onClick={() => setShowReplaceModal(true)}
                                        disabled={actionLoading}
                                        className="px-6 py-2 bg-orange-600 hover:bg-orange-700 text-white font-medium rounded-md transition-colors disabled:opacity-50"
                                    >
                                        Reemplazar Acceso Existente
                                    </button>
                                </>
                            ) : (
                                <button
                                    onClick={handleApprove}
                                    disabled={actionLoading}
                                    className="px-6 py-2 bg-green-600 hover:bg-green-700 text-white font-medium rounded-md transition-colors disabled:opacity-50"
                                >
                                    {actionLoading ? 'Procesando...' : (request.id_red_asignado ? 'Aprobar y Otorgar Acceso' : 'Aprobar y Generar ID')}
                                </button>
                            )}
                        </div>
                    </div>
                )}

                {canDarDeBaja() && (
                    <div className="border-t pt-6">
                        <h3 className="text-sm font-semibold text-red-500 uppercase mb-3">Dar de Baja</h3>
                        <p className="text-sm text-gray-600 mb-4">
                            Se dará de baja el permiso de edición sobre esta entidad.
                        </p>
                        <button
                            onClick={() => setShowBajaModal(true)}
                            disabled={actionLoading}
                            className="px-6 py-2 bg-gray-600 hover:bg-gray-700 text-white font-medium rounded-md transition-colors disabled:opacity-50"
                        >
                            Dar de Baja
                        </button>
                    </div>
                )}
            </div>

            {/* Replace Access Modal */}
            {showReplaceModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white dark:bg-gray-800 rounded-lg p-6 max-w-md w-full mx-4">
                        <h3 className="text-lg font-bold mb-4 text-gray-900 dark:text-white">
                            Reemplazar Acceso Existente
                        </h3>
                        <p className="text-sm text-gray-600 mb-4">
                            Esta acción dará de baja el acceso actual y aprobará la nueva solicitud. 
                            El usuario anterior será notificado por email.
                        </p>
                        <div className="mb-4 p-3 bg-orange-50 rounded-md">
                            <p className="text-xs text-orange-700">
                                <strong>Usuario actual:</strong> {existingRequests[0]?.nombre_presidente || 'No disponible'} ({existingRequests[0]?.email_contacto})
                            </p>
                        </div>
                        <textarea
                            value={replaceReason}
                            onChange={(e) => setReplaceReason(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 mb-4"
                            rows="4"
                            placeholder="Motivo del reemplazo (obligatorio)..."
                        />
                        <div className="flex gap-3 justify-end">
                            <button
                                onClick={() => setShowReplaceModal(false)}
                                className="px-4 py-2 text-gray-600 hover:text-gray-800"
                            >
                                Cancelar
                            </button>
                            <button
                                onClick={handleReplaceAccess}
                                disabled={actionLoading}
                                className="px-4 py-2 bg-orange-600 hover:bg-orange-700 text-white rounded-md disabled:opacity-50"
                            >
                                {actionLoading ? 'Procesando...' : 'Confirmar Reemplazo'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Rejection Modal */}
            {showRejectionModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white dark:bg-gray-800 rounded-lg p-6 max-w-md w-full mx-4">
                        <h3 className="text-lg font-bold mb-4 text-gray-900 dark:text-white">
                            Rechazar Solicitud
                        </h3>
                        <p className="text-sm text-gray-600 mb-4">
                            Por favor, ingrese el motivo del rechazo. Esto será notificado al solicitante.
                        </p>
                        <textarea
                            value={rejectionReason}
                            onChange={(e) => setRejectionReason(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 mb-4"
                            rows="4"
                            placeholder="Motivo del rechazo..."
                        />
                        <div className="flex gap-3 justify-end">
                            <button
                                onClick={() => setShowRejectionModal(false)}
                                className="px-4 py-2 text-gray-600 hover:text-gray-800"
                            >
                                Cancelar
                            </button>
                            <button
                                onClick={handleReject}
                                disabled={actionLoading}
                                className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-md disabled:opacity-50"
                            >
                                {actionLoading ? 'Procesando...' : 'Confirmar Rechazo'}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Baja Modal */}
            {showBajaModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white dark:bg-gray-800 rounded-lg p-6 max-w-md w-full mx-4">
                        <h3 className="text-lg font-bold mb-4 text-gray-900 dark:text-white">Dar de baja permiso de edición</h3>
                        <p className="text-sm text-gray-600 mb-4">Por favor, ingrese el motivo de la baja.</p>
                        <textarea
                            value={bajaReason}
                            onChange={(e) => setBajaReason(e.target.value)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500 mb-4"
                            rows="4"
                            placeholder="Motivo de la baja..."
                        />
                        <div className="flex gap-3 justify-end">
                            <button onClick={() => setShowBajaModal(false)} className="px-4 py-2 text-gray-600 hover:text-gray-800">Cancelar</button>
                            <button onClick={handleDarDeBaja} disabled={actionLoading} className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-md disabled:opacity-50">
                                {actionLoading ? 'Procesando...' : 'Confirmar Baja'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default EntidadRequestDetailPage;
